<ng-container *ngIf="dataState$ | async as dataSearchState">
  <ng-container *ngFor="let error of dataSearchState.errors">
    <div [class.hide-results]="!error?.faultCodes || !error?.faultCodes?.length">
      <div class="flex flex-col gap-[5px]">
        <vi-card *ngFor="let faultCode of error.faultCodes" class="error-card" [footer]="false">
          <div title class="flex flex-row gap-[30px] justify-start items-start">
            <div class="error-code">{{ faultCode?.faultCode }}</div>
            <div class="error-description" [innerHTML]="faultCode?.systemCharacteristics"></div>
          </div>
          <div
            body
            *ngIf="faultCode?.causes?.length"
            class="flex flex-col gap-[20px] justify-start items-start"
          >
            <div
              class="flex flex-row gap-[16px] justify-start items-start w-full min-w-full h-full min-h-full"
            >
              <mat-icon>error_outline</mat-icon>
              <div class="flex flex-col justify-start items-start">
                <vi-text data-at-cause-title size="medium" weight="bold">
                  {{
                    '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.CAUSE.TITLE'
                      | translate
                  }}
                </vi-text>
                <vi-text *ngIf="(faultCode?.causes)[0]?.cause" size="medium" data-at-cause-data>
                  <div [innerHTML]="(faultCode?.causes)[0]?.cause"></div>
                </vi-text>
                <vi-text *ngIf="!(faultCode?.causes)[0]?.cause" size="medium">
                  <div data-at-missing-cause-data>
                    {{
                      '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.MISSING_MESSAGE'
                        | translate
                    }}
                  </div>
                </vi-text>
              </div>
            </div>
            <div
              class="flex flex-row gap-[16px] justify-start items-start w-full min-w-full h-full min-h-full"
            >
              <mat-icon>build</mat-icon>
              <div class="flex flex-col justify-start items-start">
                <vi-text data-at-cause-title size="medium" weight="bold">
                  {{
                    '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.REPAIR.TITLE'
                      | translate
                  }}
                </vi-text>
                <vi-text *ngIf="(faultCode?.causes)[0]?.measure" size="medium" data-at-measure-data>
                  <div [innerHTML]="(faultCode?.causes)[0]?.measure"></div>
                </vi-text>
                <vi-text *ngIf="!(faultCode?.causes)[0]?.measure" size="medium">
                  <div data-at-missing-measure-data>
                    {{
                      '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.MISSING_MESSAGE'
                        | translate
                    }}
                  </div>
                </vi-text>
              </div>
            </div>
          </div>
        </vi-card>
      </div>
    </div>

    <vi-no-results
      imgPath="assets/img/search-guy.png"
      *ngIf="error?.loaded && (!error?.faultCodes || !error?.faultCodes?.length)"
    >
      {{ '+SEARCH.RESULT_LIST.ERROR_NOT_FOUND' | translate }}
    </vi-no-results>
  </ng-container>
</ng-container>
